import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site-config';
import { categories } from '@/mocks/articles';
import { useState } from 'react';

const footerLinks = [
  { label: '首页', path: '/' },
  { label: '51吃瓜莫里秀', path: '/category/morisxiu' },
  { label: '大英博物馆', path: '/category/british-museum' },
  { label: '明星翻车', path: '/category/star-scandal' },
  { label: '网红黑料', path: '/category/wanghong' },
  { label: '关于我们', path: '/about' },
];

const socialLinks = [
  { label: '微博', icon: 'ri-weibo-line', href: '#' },
  { label: '微信公众号', icon: 'ri-wechat-line', href: '#' },
  { label: '抖音', icon: 'ri-tiktok-line', href: '#' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMessage, setStatusMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitStatus('success');
      setStatusMessage('订阅成功！');
      setTimeout(() => { setSubmitStatus('idle'); setStatusMessage(''); }, 3000);
      return;
    }
    setSubmitStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      await fetch('https://readdy.ai/api/form/d92dt800sqa2sn3dnfj0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitStatus('success');
      setStatusMessage('订阅成功！');
      setEmail('');
      setTimeout(() => { setSubmitStatus('idle'); setStatusMessage(''); }, 3000);
    } catch {
      setSubmitStatus('error');
      setStatusMessage('订阅失败，请重试');
      setTimeout(() => { setSubmitStatus('idle'); setStatusMessage(''); }, 3000);
    }
  };

  return (
    <footer className="bg-foreground-900 text-background-50 mt-14 md:mt-20">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          <div className="lg:col-span-1">
            <h3 className="text-lg md:text-xl font-heading font-bold mb-4 text-background-50">
              加入吃瓜前线
            </h3>
            <p className="text-sm text-background-50/60 leading-relaxed">
              {siteConfig.slogan}，全网最新最全的娱乐八卦资讯平台，实时追踪网红明星翻车黑料。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold mb-4 text-background-50/80 uppercase tracking-wider">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold mb-4 text-background-50/80 uppercase tracking-wider">
              关注我们
            </h4>
            <ul className="flex flex-col gap-2.5">
              {socialLinks.map((social) => (
                <li key={social.label}>
                  <a
                    href={social.href}
                    className="flex items-center gap-2 text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    rel="nofollow"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={social.icon}></i>
                    </span>
                    {social.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold mb-4 text-background-50/80 uppercase tracking-wider">
              订阅更新
            </h4>
            <p className="text-sm text-background-50/50 mb-4 leading-relaxed">
              第一时间获取最新爆料推送
            </p>
            <form
              className="flex gap-0"
              data-readdy-form="true"
              onSubmit={handleSubscribe}
            >
              <input
                type="email"
                name="email"
                placeholder="输入邮箱地址"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="flex-1 px-4 py-2.5 text-sm bg-background-50/10 border border-background-50/20 rounded-l-md text-background-50 placeholder:text-background-50/30 outline-none focus:border-primary-400/60 transition-colors"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="form-hp-field"
              />
              <button
                type="submit"
                disabled={submitStatus === 'loading'}
                className="w-11 h-11 flex items-center justify-center bg-primary-500 hover:bg-primary-600 disabled:opacity-50 rounded-r-md cursor-pointer transition-colors duration-200 whitespace-nowrap"
              >
                {submitStatus === 'loading' ? (
                  <i className="ri-loader-4-line animate-spin text-background-50 text-lg"></i>
                ) : (
                  <i className="ri-arrow-right-line text-background-50 text-lg"></i>
                )}
              </button>
            </form>
            {statusMessage && (
              <p className={`text-xs mt-2 ${submitStatus === 'error' ? 'text-red-400' : 'text-green-400'}`}>
                {statusMessage}
              </p>
            )}
          </div>
        </div>

        <div className="mt-14 md:mt-16 pt-8 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/30">
              &copy; {new Date().getFullYear()} 51吃瓜官网 - 吃瓜无罪 八卦有理
            </p>
            <div className="flex items-center gap-6">
              <Link to="/about" className="text-xs text-background-50/30 hover:text-background-50/50 transition-colors cursor-pointer">关于我们</Link>
              <span className="text-xs text-background-50/20">|</span>
              <span className="text-xs text-background-50/30">全网独家吃瓜爆料入口</span>
            </div>
          </div>
        </div>
      </div>

      <div className="relative overflow-hidden h-20 md:h-24">
        <span className="absolute inset-0 flex items-center justify-center text-[80px] md:text-[120px] font-heading font-black text-background-50/[0.03] whitespace-nowrap select-none pointer-events-none">
          51吃瓜
        </span>
      </div>
    </footer>
  );
}